import styled from 'styled-components';
import { useState, useEffect } from 'react';
import CompInboxTable from './CompInboxTable';
import ComplaintDetails from '../ComplaintDetails';
import { useMarkAsReadMutation } from '../../../features/complaints/complaintsApiSlice';
import { useGetComplaintsQuery } from '../../../features/complaints/complaintsApiSlice';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const Wrapper = styled.div``;

const CompInbox = ({ subTabValue, resetTrigger }) => {
  const [row, setRow] = useState('');
  const [changepage, setChangepage] = useState([true, false, false, false, false]);
  const [markAsReadMutation] = useMarkAsReadMutation();

  // Get complaints data to find full complaint details by ID
  const { complaints } = useGetComplaintsQuery("complaints", {
    selectFromResult: ({ data }) => ({
      complaints: data?.entities
    }),
  });

  useEffect(() => {
    if (resetTrigger > 0) {
      setChangepage([true, false, false, false, false]);
      // Reset any other state variables that need resetting
    }
  },[resetTrigger])

  const handleEditclick = async (e, rowData, reqtype) => {
    console.log('Complaint reqtype:', reqtype);
    console.log('Row data received:', rowData);
    
    // Find full complaint data if only ID is provided
    let fullComplaintData = rowData;
    if (rowData?._id && complaints && !rowData.complaintNo) {
      fullComplaintData = complaints[rowData._id] || rowData;
    }
    
    setRow(fullComplaintData);
    
    // Mark the complaint as read when user clicks view/action button
    try {
      await markAsReadMutation({
        requestId: fullComplaintData._id || fullComplaintData.id,
        requestType: 'complaint'
      }).unwrap();
      console.log('Complaint marked as read successfully');
    } catch (error) {
      console.error('Error marking complaint as read:', error);
    }
  
    if (["ViewComplaint", "ProcessComplaint"].includes(reqtype)) {
      setChangepage([false, true, false, false, false]);
    } else if (["ComplaintDetails"].includes(reqtype)) {
      setChangepage([false, false, true, false, false]);
    } else if (reqtype === "direct") {
      setChangepage([false, false, false, false, true]);
    }
  };
  
  return (
    <Container>
      <Wrapper>
        {(changepage[0]) && <CompInboxTable subTabValue={subTabValue} handleEditclick={handleEditclick} />}
        {(changepage[1]) && <ComplaintDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {/* Additional complaint detail components can be added here */}
      </Wrapper>
    </Container>
  );
};

export default CompInbox; 